export const cardTypes = [
    { label: "Editing", value: 'editing' },
    { label: "Video Request", value: "video_request" },
    { label: "Done", value: "done" },
    { label: "Due Date", value: "due_date" }
];

export const TimePeriod = [
    { label: "This Month", value: 'current_month' },
    { label: "Previous Month", value: 'last_month' },
    { label: "Month Before Last", value: 'last_2_months' },
    { label: "3 Months Ago", value: 'last_3_months' },
]
